import { create } from 'zustand';

/**
 * Client-only UI flags. Trip data lives in TanStack Query + localStorage (see lib/repository).
 */
export const useTravelBuddyUi = create<{
  /** When true, modals can hide chrome (optional — wire from modals if needed) */
  modalOpen: boolean;
  setModalOpen: (v: boolean) => void;
}>((set) => ({
  modalOpen: false,
  setModalOpen: (modalOpen) => set({ modalOpen }),
}));
